import { getNameInitials } from '@framework/ui';
import { Tag, Tooltip } from 'antd';
import * as React from 'react';
import styled from 'styled-components';

const StyledTag = styled(Tag)<{ $mini?: boolean }>`
  /* letter-spacing: 0.03em; */
  font-weight: 400;
  line-height: ${props => (props.$mini ? '14px' : '20px')};
  padding-inline: ${props => (props.$mini ? '4px' : '7px')};
`;

/**
 * Ritorna le impostazioni per il tag
 *
 */
function getTagOrCodeOptions(name: string, code?: boolean) {
  return code
    ? { children: <Tooltip title={name}>{getNameInitials(name)}</Tooltip> }
    : { children: name };
}

export interface IAttachmentTypeTagProps {
  name?: string | null;
  /** Versione compatta */
  mini?: boolean;
  /** Versione solo Iniziali */
  codeOnly?: boolean;
}

/**
 * Tipo di allegato della comunicazione
 */
export function AttachmentTypeTag(props: IAttachmentTypeTagProps) {
  const { name, mini, codeOnly } = props;
  if (!name) return null;

  return <StyledTag $mini={mini} {...getTagOrCodeOptions(name, codeOnly)} />;
}
